<svg [attr.height]="height" [attr.width]="width" [ngStyle]="{color}">
  <use [attr.xlink:href]="'#'+name"></use>
</svg>
